import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ar from "./locales/ar.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";

// اللغات المدعومة، وكل لغة عارفة اتجاهها (عربي = RTL، إنجليزي وفرنسي = LTR)
export const supportedLanguages = {
  ar: { label: "العربية", dir: "rtl", resources: ar },
  en: { label: "English", dir: "ltr", resources: en },
  fr: { label: "Français", dir: "ltr", resources: fr }
};

export const defaultLanguage = "ar";

i18n.use(initReactI18next).init({
  resources: {
    ar: { translation: ar },
    en: { translation: en },
    fr: { translation: fr }
  },
  lng: defaultLanguage,
  fallbackLng: defaultLanguage,
  interpolation: { escapeValue: false }
});

/**
 * بيغيّر اللغة الفعلية + اتجاه الصفحة (RTL/LTR) + خاصية lang في HTML
 * (مهم لمحركات البحث ولقارئات الشاشة، مش بس للشكل)
 */
export function applyLanguage(lang) {
  const config = supportedLanguages[lang] || supportedLanguages[defaultLanguage];
  i18n.changeLanguage(lang in supportedLanguages ? lang : defaultLanguage);
  document.documentElement.setAttribute("lang", lang in supportedLanguages ? lang : defaultLanguage);
  document.documentElement.setAttribute("dir", config.dir);
}

export default i18n;

/**
 * Hook بسيط بيرجع بادئة اللغة الحالية للروابط الداخلية (مثال: "" للعربي، "/en" للإنجليزي)
 * لازم يتستخدم جوه صفحة موجودة تحت LanguageWrapper (يعني أي صفحة تقريبًا في التطبيق)
 */
export function useLangPrefix() {
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  const seg = path.split("/")[1];
  return seg in supportedLanguages && seg !== defaultLanguage ? `/${seg}` : "";
}
